import axios from 'axios'
import { UpdateType, type VersionPolicy } from '@numeo/types'
import { mainServiceRootAxios } from 'setup/SetupAxios'

export { UpdateType }
export type { VersionPolicy }

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export const extensionVersionPolicyApi = {
    get: async (): Promise<VersionPolicy | null> => {
        const res = await axios.get<Envelope<{ extensionVersion: VersionPolicy | null }>>('/gluon/config/extension-version')
        return res.data.data.extensionVersion ?? null
    },

    setPolicy: async (policy: VersionPolicy): Promise<VersionPolicy> => {
        const res = await axios.put<Envelope<{ policy: VersionPolicy }>>('/gluon/config/extension-version', { policy })
        return res.data.data.policy
    },

    clearPolicy: async (): Promise<void> => {
        await axios.delete<Envelope<Record<string, never>>>('/gluon/config/extension-version')
    },

    // Live-tests the consumer endpoint to show what the extension would actually receive
    // for a given installed version, so the editor can see hard/soft/none before publishing.
    // Uses the root axios instance — the consumer endpoint is new-convention (/extension/...),
    // mounted at the app root, not under /v1.
    preview: async (currentVersion: string): Promise<{ updateType: UpdateType }> => {
        const res = await mainServiceRootAxios.get<Envelope<{ updateType: UpdateType }>>(
            `/extension/version-check/v1?version=${encodeURIComponent(currentVersion)}`
        )
        return res.data.data
    },
}
